import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t, type IntlService } from 'ember-intl'
import { formatNumber } from 'teacher-ui-client/utils/giraffe/formatter'
import TrophyGold from '@images/giraffe/trophy-gold.svg'
import TrophySilver from '@images/giraffe/trophy-silver.svg'
import TrophyBronze from '@images/giraffe/trophy-bronze.svg'
import type { TOC } from '@ember/component/template-only'
import type { AwardsEarnedData } from 'teacher-ui-client/utils/student-events/fetchers/awards-earned'

export interface TrophyViewModel {
  value: string
  label: string
  src: string
}

interface Signature {
  Element: HTMLDivElement
  Args: {
    data: AwardsEarnedData
  }
}

export class AwardsEarnedTrophies extends Component<Signature> {
  @service intl!: IntlService

  get goldTrophy(): TrophyViewModel {
    return {
      value: formatNumber(this.args.data.gold, 0),
      label: this.intl.t('awards.gold'),
      src: TrophyGold,
    }
  }

  get silverTrophy(): TrophyViewModel {
    return {
      value: formatNumber(this.args.data.silver, 0),
      label: this.intl.t('awards.silver'),
      src: TrophySilver,
    }
  }

  get bronzeTrophy(): TrophyViewModel {
    return {
      value: formatNumber(this.args.data.bronze, 0),
      label: this.intl.t('awards.bronze'),
      src: TrophyBronze,
    }
  }

  <template>
    <div class="mx-auto flex max-w-md items-center justify-center" data-test-awards-earned-trophies ...attributes>
      <Trophy class="mt-12 w-1/3" @trophy={{this.goldTrophy}} />
      <Trophy class="-mt-12 w-1/3" @trophy={{this.silverTrophy}} />
      <Trophy class="mt-12 w-1/3" @trophy={{this.bronzeTrophy}} />
    </div>
  </template>
}

interface TrophySignature {
  Element: HTMLDivElement
  Args: {
    trophy: TrophyViewModel
  }
}

export const Trophy: TOC<TrophySignature> = <template>
  <div class="relative" ...attributes>
    <img src={{@trophy.src}} class="drop-shadow-[7px_7px_1px_#E0E0E0]" alt={{t "awards.trophy"}} />
    <div class="absolute top-[20%] left-1/2 -translate-x-1/2 transform text-2xl leading-none font-bold text-black">
      {{@trophy.value}}
    </div>
    <div class="absolute top-[40%] left-1/2 -translate-x-1/2 transform text-xl leading-none font-bold text-white">
      {{@trophy.label}}
    </div>
  </div>
</template>
